module.exports = __webpack_public_path__ + "img/20200427144617TIM截图20200427143113.1435a458.png";